import TableDetail from './TableDetail'

export default TableDetail
